import type { ButtonProps, HStackProps } from '@rbilabs/universal-components';

import type { ActionButtonGradientConfig } from '../types';

type LinearGradientBackground = NonNullable<HStackProps['background']>;

export const getActionButtonLinearGradientProps = (
  gradient?: ActionButtonGradientConfig,
  stackProps?: ButtonProps['_stack']
): Partial<ButtonProps> => {
  if (!gradient) {
    return {};
  }

  const background = {
    linearGradient: {
      colors: [...gradient.colors],
      locations: gradient.locations ? [...gradient.locations] : undefined,
      start: gradient.start ? [gradient.start.x, gradient.start.y] : undefined,
      end: gradient.end ? [gradient.end.x, gradient.end.y] : undefined,
    },
  } as LinearGradientBackground;

  return {
    px: 0,
    py: 0,
    _stack: {
      ...stackProps,
      alignSelf: 'stretch',
      background,
      borderRadius: 'full',
      justifyContent: 'center',
      px: '4',
      py: '2',
      width: '100%',
    },
  };
};
